module.exports = __webpack_public_path__ + "images/emoji/b.5d401dc3b3611796f21a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/b.png
// module id = pcl5
// module chunks = 1